import { Component } from 'react';
import { themeService } from '../services/theme/ThemeService';
import React from 'react';
import { loadBaseThemes } from '../loader';

export const withThemeLoader = (WrappedComponent, theme) => {
  
  class WithThemeLoader extends Component {
    
    componentWillMount() {
      themeService.includeTheme(theme);
    }
    
    componentWillUnmount() {
      loadBaseThemes();
    }
    
    render() {
      return (<WrappedComponent {...this.props} />)
    }
    
  }
  
  return WithThemeLoader;
  
};
